<template>
	<el-dialog title="确定要移除该店铺？" :visible.sync="visible" width="400px" :before-close="beforeClose" :close-on-click-modal="false">
		<div class="flex-row flex-align-start yx-color-text-primary font-h4-regular">
			<i class="el-icon-warning yx-color-warning mt-4"></i>
			<p class="ml-4">移除后该店铺将按全局协作规则来发送协作信息，确认要移除么？</p>
		</div>
		<div slot="footer">
			<el-button @click="beforeClose">取消</el-button>
			<el-button type="primary" @click="confirm">确认移除</el-button>
		</div>
	</el-dialog>
</template>
<script>
import { institutionDelRule } from '@/api/cooperativeShop';
export default {
	props: {
		platformId: {
			type: [String, Number],
			default: +dataMap.PLATFORM_DY.value,
		},
	},
	data() {
		return {
			visible: false,
			id: '',
		};
	},
	methods: {
		show(id) {
			this.shopId = id;
			this.visible = true;
		},
		beforeClose() {
			this.shopId = '';
			this.visible = false;
		},
		async confirm() {
			const { platformId, shopId } = this;
			await institutionDelRule({ platformId, shopId });
			this.$emit('refresh');
			this.$message.success('删除成功！');
			this.beforeClose();
		},
	},
};
</script>
<style lang="less" scoped></style>
